import type {
  TenantMember,
  TenantMembersResponse,
  CreateTenantMemberRequest,
  CreateTenantMemberResponse,
  UpdateTenantMemberRoleRequest,
  UpdateTenantMemberRoleResponse,
} from '@resolve-ai/shared';

import { fetchWithAuth } from './api-client';

export const usersApi = {
  async getTenantMembers(): Promise<TenantMember[]> {
    const response = await fetchWithAuth<TenantMembersResponse>('/users/me/team-members');
    return response.members;
  },

  async createTenantMember(request: CreateTenantMemberRequest): Promise<TenantMember> {
    const response = await fetchWithAuth<CreateTenantMemberResponse>('/users/me/team-members', {
      method: 'POST',
      body: JSON.stringify(request),
    });

    return response.member;
  },

  async updateTenantMemberRole(
    userId: string,
    request: UpdateTenantMemberRoleRequest
  ): Promise<TenantMember> {
    const response = await fetchWithAuth<UpdateTenantMemberRoleResponse>(
      `/users/me/team-members/${userId}/role`,
      {
        method: 'PATCH',
        body: JSON.stringify(request),
      }
    );

    return response.member;
  },

  async deleteTenantMember(userId: string): Promise<void> {
    await fetchWithAuth<void>(`/users/me/team-members/${userId}`, {
      method: 'DELETE',
    });
  },
};
